import { render, staticRenderFns } from "./copyrightLogin.vue?vue&type=template&id=0e17d56a&scoped=true&"
import script from "./copyrightLogin.vue?vue&type=script&lang=js&"
export * from "./copyrightLogin.vue?vue&type=script&lang=js&"
import style0 from "./copyrightLogin.vue?vue&type=style&index=0&id=0e17d56a&scoped=true&lang=less&"
import style1 from "./copyrightLogin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e17d56a",
  null
  
)

export default component.exports